<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <span class="col-form-label">Are the parts accepted or rejected? Please specify the accept and reject quantities below and add any other notes.</span>
      <b-form-radio-group
        :options="['Parts Accepted', 'Parts Rejected']"
        v-model="model.partAcceptance_AcceptedOrRejected"
      >
      </b-form-radio-group>
      <!-- <b-form-group label="Parts to be accepted or rejected" v-model="model.partAcceptance_AcceptedOrRejected">
          <b-form-radio-group :options="['Parts Rejected', 'Parts Accepted']"></b-form-radio-group>
      </b-form-group>-->
      <b-form-group label="Qty Accepted" label-cols-sm="1">
        <b-form-input type="number" class="col-3" v-model="model.partAcceptance_QtyAccepted"></b-form-input>
      </b-form-group>
      <b-form-group label="Qty Rejected" label-cols-sm="1">
        <b-form-input type="number" class="col-3" v-model="model.partAcceptance_QtyRejected"></b-form-input>
      </b-form-group>
      <b-form-group label="Notes" label-cols-sm="1">
        <b-textarea class="col-4" v-model="model.partAcceptance_Notes"></b-textarea>
      </b-form-group>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'aegisPartAcceptance',
  components: {},
  props: {
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        partAcceptance_AcceptedOrRejected: this.inspectionDetails[FIELDS.PART_ACCEPTANCE__ACCEPTED_OR_REJECTED] || '',
        partAcceptance_QtyAccepted: this.inspectionDetails[FIELDS.PART_ACCEPTANCE__QTY_ACCEPTED] || '',
        partAcceptance_QtyRejected: this.inspectionDetails[FIELDS.PART_ACCEPTANCE__QTY_REJECTED] || '',
        partAcceptance_Notes: this.inspectionDetails[FIELDS.PART_ACCEPTANCE__NOTES] || '',
      },
    };
  },
  computed: {},
  mounted() {},
};
</script>